import { useCallback, useEffect, useState } from "react";
import useWebSocket from "react-use-websocket";
import { v4 as uuidv4 } from "uuid";
import { useCookies } from "react-cookie";

const socketUrl = "wss://brmm0q8jaa.execute-api.eu-central-1.amazonaws.com/production";

export function useTwintPayment() {
  const [cookies] = useCookies(["secret", "station", "staff"]);

  const [status, setStatus] = useState({ code: null, amount: 0 });
  const [currentAmount, setCurrentAmount] = useState(0);
  const [paymentId, setPaymentId] = useState(null);
  const [rate, setRate] = useState(1);
  const [currency, setCurrency] = useState('CHF');

  const handleReset = () => {
    setStatus({ code: null, amount: 0 })
    setCurrentAmount(0);
    setPaymentId(null);
  };

  const { sendMessage } = useWebSocket(socketUrl, {
    queryParams: {
      station: cookies.station,
      secret: cookies.secret,
      staff: cookies.staff
    },
    shouldReconnect: () => true,
    onMessage: (msg) => handleMessage(msg)
  });

  const handleMessage = (message) => {
    const msg = JSON.parse(message.data);

    if (msg.task === "respRequestTwintPayment") {

      setPaymentId(msg.paymentId);
      setRate(msg.rate);
      setCurrency(currency);
    }

    if (msg.task === "twintPaymentResponseAvailable") {
      sendMessage(
        JSON.stringify({
          task: "validateTwintPayment",
          station: cookies.station,
          staff: cookies.staff,
          mode: 'TEST',
          paymentId
        })
      );
    }

    if (msg.task === "respValidateTwintPayment") {
      const statusCode = msg.payment_status;

      if (["paid"].includes(statusCode)) {
        setStatus({ code: "SUCCESS", amount: currentAmount, currency, rate });
      } else if (["canceled", "failed", "expired"].includes(statusCode)) {
        setStatus({ code: "FAILED", amount: 0 });
      } else {
        setTimeout(() => {
          sendMessage(
            JSON.stringify({
              task: "validateTwintPayment",
              station: cookies.station,
              staff: cookies.staff,
              mode: 'TEST',
              paymentId
            })
          );
        }, 1000);
      }
    }
  };

  const initiateTwintPayment = useCallback((amount) => {
    setCurrentAmount(amount);
    setStatus({ code: "PENDING", amount: 0 });
    sendMessage(
      JSON.stringify({
        task: "requestTwintPayment",
        station: cookies.station,
        staff: cookies.staff,
        amount,
        mode: 'TEST',
        kdnr: null // optional
      })
    );
  }, [sendMessage, cookies.station, cookies.staff]);

  const retryPayment = useCallback(() => {
    if (status.code === "PENDING") {
      initiateTwintPayment(currentAmount);
    }
  }, [status.code, currentAmount, initiateTwintPayment]);

  return {
    initiateTwintPayment,
    retryPayment,
    handleReset,
    twintStatus: status
  };
}
